import styled, { css, keyframes } from "styled-components";

const sophisticatedRing = keyframes`
    0% {
        transform: rotate(0deg);
    }
    
    4% {
        transform: rotate(-2deg);
    }
    
    8% {
        transform: rotate(14deg);
    }
    14% {
        transform: rotate(-12deg);
    }
    20% {
        transform: rotate(9deg);
    }
    26% {
        transform: rotate(-6deg);
    }
    32% {
        transform: rotate(3deg);
    }
    38% {
        transform: rotate(-1.5deg);
    }
    44% {
        transform: rotate(0.5deg);
    }
    
    50%, 100% {
        transform: rotate(0deg);
    }
`;

const subtleGlow = keyframes`
    0%, 100% {
        filter: drop-shadow(0 0 0px rgba(62, 116, 254, 0));
    }
    8% {
        filter: drop-shadow(0 0 4px rgba(62, 116, 254, 0.4));
    }
    50% {
        filter: drop-shadow(0 0 0px rgba(62, 116, 254, 0));
    }
`;

export const Container = styled.div<{ $shouldShowAnimation?: boolean }>`
    display: inline-flex;
    transform-origin: center 20%;

    ${({ $shouldShowAnimation }) =>
        $shouldShowAnimation &&
        css`
            animation:
                ${sophisticatedRing} 5s cubic-bezier(0.34, 1.56, 0.64, 1),
                ${subtleGlow} 5s ease-out;
        `}
`;
